import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const useCustomFieldUrl = (customFieldResponseId: number): string => {
    const { accountId } = useCurrentAccount();
    const { apiUrl } = useAppState();

    if (!customFieldResponseId) {
        return '';
    }

    return `${apiUrl}/dashboard/accounts/${accountId}/custom-field-responses/${customFieldResponseId}/access-file`;
};

export { useCustomFieldUrl };
